// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "vendors-65d5dd59818ec8c789bd.js";
	// return url for filenames based on template
	return "" + ({"271":"__federation_expose_filter_input","522":"__federation_expose_document_list","661":"__federation_expose_filter_select","943":"__federation_expose_handlers"}[chunkId] || chunkId) + "-" + {"231":"c95c055abdde965ba145","271":"76431eee8fd6ef8f5e1b","522":"d08e63e80770be3505e3","661":"bc405a9cfe7906786be6","943":"54a86d7a29911b2fd255"}[chunkId] + ".js";
};